/* Your Pet Memory — theme scripts (no dependencies) */
(function () {
  'use strict';
  var d = document, w = window, C = w.YPM || {};
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { w.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Analytics: publish custom events for Shopify Customer Events pixels ---------- */
  function track(name, data) {
    data = data || {};
    try { if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  w.ypmTrack = track;
  if (w.YPM_VIEW_ITEM) track('ypm_view_item', w.YPM_VIEW_ITEM);

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.classList && f.classList.contains('ypm-buy')) {
      track('ypm_cta_click', { source: f.getAttribute('data-src') || 'cta', variant_id: C.variant, value: C.price, currency: C.currency });
    }
  }, true);
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/pages/how-to-use') > -1) track('ypm_how_to_use_click', { href: href });
    if (a.getAttribute('data-track') === 'blog_product_click' || (C.template === 'article' && href.indexOf('/products/') > -1)) track('ypm_blog_product_click', { href: href });
    if (a.getAttribute('data-track') === 'freebie_download') track('ypm_freebie_download', {});
  });
  if ($('[data-signup-success]')) track('ypm_email_signup', { method: 'customer_form' });

  /* ---------- Reveal on scroll ---------- */
  var rv = $$('.rv');
  if ('IntersectionObserver' in w && rv.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- Drawer ---------- */
  var drawer = $('[data-drawer]'), opener = $('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var f = $('a,button', drawer.querySelector('.drawer__panel')); if (f) f.focus(); } else if (opener) opener.focus();
  }
  if (opener) opener.addEventListener('click', function () { setDrawer(true); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (drawer && drawer.classList.contains('is-open')) setDrawer(false); closePopup(); } });

  /* ---------- Promotion end + countdown ---------- */
  var end = C.promoEnd ? Date.parse(C.promoEnd) : NaN;
  function promoEnded() { return !isNaN(end) && Date.now() > end; }
  if (promoEnded()) $$('[data-promo]').forEach(function (el) { el.classList.add('is-ended'); });
  var cds = $$('[data-countdown]');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var t = end - Date.now();
    if (isNaN(t)) return;
    if (t <= 0) { $$('[data-promo]').forEach(function (el) { el.classList.add('is-ended'); }); return; }
    var s = Math.floor(t / 1000), dd = Math.floor(s / 86400), hh = Math.floor(s % 86400 / 3600), mm = Math.floor(s % 3600 / 60), ss = s % 60;
    cds.forEach(function (c) {
      var a = c.querySelector('[data-d]'), b = c.querySelector('[data-h]'), m = c.querySelector('[data-m]'), x = c.querySelector('[data-s]');
      if (a) a.textContent = pad(dd); if (b) b.textContent = pad(hh); if (m) m.textContent = pad(mm); if (x) x.textContent = pad(ss);
    });
  }
  if (cds.length && !promoEnded()) { tick(); setInterval(tick, 1000); }

  /* ---------- Sticky bar ---------- */
  var sticky = $('[data-sticky]');
  if (sticky) {
    var hideZones = $$('#pricing, .final, .ftr, .pdp__box');
    var visibleZones = 0;
    if ('IntersectionObserver' in w) {
      var zio = new IntersectionObserver(function (es) {
        es.forEach(function (en) { en.target.__v = en.isIntersecting; });
        visibleZones = hideZones.filter(function (z) { return z.__v; }).length;
        update();
      }, { threshold: 0.15 });
      hideZones.forEach(function (z) { zio.observe(z); });
    }
    var update = function () {
      var on = w.scrollY > 760 && visibleZones === 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    w.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Email popup ---------- */
  var pop = $('[data-popup]');
  function openPopup() {
    if (!pop || pop.classList.contains('is-open')) return;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    store.set('ypm_pop_seen', String(Date.now()));
    var f = pop.querySelector('input:not([type=hidden])'); if (f) setTimeout(function () { f.focus(); }, 350);
  }
  function closePopup() {
    if (!pop || !pop.classList.contains('is-open')) return;
    pop.classList.remove('is-open');
    setTimeout(function () { pop.hidden = true; }, 400);
  }
  if (pop) {
    $$('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', closePopup); });
    if (pop.querySelector('[data-signup-success]') || (pop.querySelector('.notice--err'))) { openPopup(); }
    else if (C.popup) {
      var seen = parseInt(store.get('ypm_pop_seen') || '0', 10);
      var subscribed = store.get('ypm_subscribed');
      if (!subscribed && Date.now() - seen > 7 * 864e5) {
        setTimeout(openPopup, (C.popupDelay || 25) * 1000);
        if (w.matchMedia && w.matchMedia('(pointer:fine)').matches) {
          d.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8 && w.scrollY > 400) openPopup(); });
        }
      }
    }
  }
  $$('form.ypm-signup').forEach(function (f) { f.addEventListener('submit', function () { store.set('ypm_subscribed', '1'); }); });

  /* ---------- Brand film ---------- */
  $$('[data-film]').forEach(function (box) {
    var v = box.querySelector('video'), play = box.querySelector('[data-film-play]'), snd = box.querySelector('[data-film-sound]');
    if (!v) { if (play) play.hidden = true; return; }
    var loaded = false;
    function load() { if (loaded) return; var s = v.querySelector('source[data-src]'); if (s) { s.src = s.getAttribute('data-src'); v.load(); } loaded = true; }
    function start(withSound) {
      load(); if (withSound) v.muted = false;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      if (play) play.hidden = true; if (snd) { snd.hidden = false; snd.textContent = v.muted ? 'Sound on' : 'Sound off'; }
    }
    if (play) play.addEventListener('click', function () { start(true); track('ypm_video_play', {}); });
    if (snd) snd.addEventListener('click', function () { v.muted = !v.muted; snd.textContent = v.muted ? 'Sound on' : 'Sound off'; });
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in w && !reduce) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { if (!loaded || v.paused) start(false); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: 0.45 }).observe(box);
    }
  });

  /* ---------- Product demo stepper ---------- */
  $$('[data-demo]').forEach(function (demo) {
    var steps = $$('[data-step]', demo), shots = $$('[data-shot]', demo), bar = $('[data-demo-bar]', demo), cnt = $('[data-demo-count]', demo);
    var i = 0, timer = null, shown = 0;
    function countTo(n) {
      var from = shown, t0 = performance.now();
      function f(t) { var p = Math.min(1, (t - t0) / 900); var val = Math.round(from + (n - from) * p); if (cnt) cnt.textContent = val; if (p < 1) requestAnimationFrame(f); else shown = n; }
      requestAnimationFrame(f);
      if (bar) bar.style.width = n + '%';
    }
    function go(k) {
      i = k;
      steps.forEach(function (s, j) { s.classList.toggle('is-on', j === k); });
      shots.forEach(function (s, j) { s.classList.toggle('is-on', j === k); });
      countTo(parseInt(steps[k].getAttribute('data-progress') || '0', 10));
    }
    steps.forEach(function (s, j) { s.addEventListener('click', function () { clearInterval(timer); timer = null; go(j); }); });
    if ('IntersectionObserver' in w) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && !timer && steps.length) { go(i); timer = setInterval(function () { go((i + 1) % steps.length); }, 3800); }
          else if (!en.isIntersecting && timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.35 }).observe(demo);
    } else if (steps.length) go(0);
  });

  /* ---------- Reviews ---------- */
  $$('[data-review-open]').forEach(function (b) {
    b.addEventListener('click', function () { var f = $('[data-review-form]'); if (f) { f.classList.add('is-open'); f.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
  });
  if (location.search.indexOf('contact_posted=true') > -1) { var rf = $('[data-review-form]'); if (rf && rf.querySelector('.notice')) rf.classList.add('is-open'); }
  var grid = $('[data-reviews]');
  if (grid) {
    var cards = $$('.rv-card', grid);
    $$('[data-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var f = b.getAttribute('data-filter');
        var list = cards.slice();
        if (f === 'top') list.sort(function (a, c) { return c.getAttribute('data-rating') - a.getAttribute('data-rating'); });
        else list.sort(function (a, c) { return c.getAttribute('data-date') - a.getAttribute('data-date'); });
        list.forEach(function (c) {
          var pet = c.getAttribute('data-pet') || '';
          c.hidden = (f === 'dog' && pet.indexOf('dog') < 0) || (f === 'cat' && pet.indexOf('cat') < 0);
          grid.appendChild(c);
        });
      });
    });
    var more = $('[data-reviews-more]');
    if (more) more.addEventListener('click', function () { $$('[data-more]', grid).forEach(function (c) { c.hidden = false; }); more.remove(); });
  }

  /* ---------- Product gallery ---------- */
  $$('[data-pdp]').forEach(function (p) {
    var th = $$('[data-thumb]', p), sl = $$('[data-slide]', p);
    th.forEach(function (t, j) {
      t.addEventListener('click', function () {
        th.forEach(function (x, k) { x.setAttribute('aria-current', k === j ? 'true' : 'false'); });
        sl.forEach(function (x, k) { x.classList.toggle('is-on', k === j); });
      });
    });
  });

  /* ---------- Article: table of contents + inline CTA ---------- */
  var body = $('[data-article-body]'), toc = $('[data-toc]');
  if (body && toc) {
    var hs = $$('h2', body);
    if (hs.length >= 3) {
      var ol = toc.querySelector('ol');
      hs.forEach(function (h, i) {
        if (!h.id) h.id = (h.textContent || 'section').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 's' + i;
        var li = d.createElement('li'), a = d.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
      });
      toc.hidden = false;
      var links = $$('a', toc);
      if ('IntersectionObserver' in w) {
        var tio = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + en.target.id); }); });
        }, { rootMargin: '0px 0px -70% 0px' });
        hs.forEach(function (h) { tio.observe(h); });
      }
      var cta = $('[data-article-cta]');
      if (cta && hs.length >= 5) { var mid = hs[Math.floor(hs.length / 2)]; mid.parentNode.insertBefore(cta.cloneNode(true), mid); }
    }
  }

  /* ---------- Toast for ?added ---------- */
  if (location.hash === '#added') {
    var t = d.createElement('div'); t.className = 'toast'; t.textContent = 'Added to your cart'; d.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-on'); }, 50); setTimeout(function () { t.classList.remove('is-on'); }, 3000);
  }
})();
